<template>
  <app-navbar />
  <section class="page_404">
    <div class="row md:text-base">
      <div class="">
        <span class="txt-404 font-bold text-2xl md:text-5xl">Page Not Found</span>
        <div class="text-center">
          <div class="four_zero_four_bg" />

          <div class="contant_box_404">
            <h1 class="h2 txt-404 error_txt">
              Looks like you're lost
            </h1>
            <p class="h2 desc  my-8 hidden md:block ">
              The page you are looking for is not available!
            </p>
            <div class="h2">
              <a href="/" class="link_404">Go to Home</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- <footer class="footer text-center py-3 bg-blue-600 text-white">
    <p class="text-sm">
      Copyright © 2022 Gill Brother Plumbing & Heating Ltd. All Rights
      Reserved. | Made with <span class="text-rose-600">❤</span> by Algoson
      Software
    </p>
  </footer> -->
</template>

<script>
import AppNavbar from "./Navbar.vue";

export default {
  name: "PageNotFound",
  components: {
    AppNavbar,
  },
};
</script>

<style scoped>
.page_404 {
  margin-top: 10%;
  background: #fff;
}

.error_txt {
  font-size: 50px;
}

.desc {
  font-size: 25px;
}

.page_404 img {
  width: 100% !important;
}

.four_zero_four_bg {
  background-image: url("../../assets/v-1.1/Icons/dribbble_1.gif");
  height: 300px;
  width: 100% !important;
  background-position: center;
  background-size: auto !important;
  background-repeat: no-repeat !important;
}

a:link {
  text-decoration: none;
}

.four_zero_four_bg h1 {
  font-size: 80px;
}

.four_zero_four_bg h3 {
  font-size: 80px;
}

.link_404 {
  color: #fff !important;
  padding: 10px 20px;
  background: #2459d8;
  margin: 20px 0;
  display: inline-block;
}

.contant_box_404 {
  margin-top: 10px;
}

.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
}

.txt-404 {
  font-size: 60px;
  display: flex;
  justify-content: center;
}

@media (max-width:780px) {
  .page_404 {
    margin-top: 3%;
  }

  .txt-404 {
    font-size: 25px;
  }

  .link_404 {
    margin: 10px 0;
  }

  .page_404 {
    padding: 150px 0;
    background: #fff;
  }

  .four_zero_four_bg {
    margin-left: auto;
    margin-right: auto;
    width: 80% !important;
  }

  .contant_box_404 {
    padding-left: 0.4rem;
    padding-right: 0.4rem;
  }
}
</style>